import React from "react";
import { Menu, Store } from "lucide-react";
import { useMarketplace } from "@context/MarketplaceContext";
import { useAuth } from "@context/AuthContext";

export default function OCTopbar({ onMenuClick }) {
  const { isSuperAdmin, isMarketplaceAdmin, marketplaces, activeMarketplaceId, setActiveMarketplace } =
    useMarketplace();
  const { user } = useAuth();

  const showSwitcher = isMarketplaceAdmin && marketplaces.length > 0;
  const activeMarketplace = marketplaces.find(
    (m) => String(m.franchise_id) === String(activeMarketplaceId)
  );

  return (
    <header className="oc-topbar">
      <div className="oc-topbar-left">
        <button
          type="button"
          className="oc-menu-btn"
          aria-label="Open menu"
          onClick={onMenuClick}
        >
          <Menu size={18} strokeWidth={2} />
          <span>Menu</span>
        </button>

        {showSwitcher ? (
          <div className="oc-marketplace-switcher" title="Active marketplace">
            <Store size={16} strokeWidth={1.8} />
            <select
              className="oc-input"
              value={activeMarketplaceId || ""}
              onChange={(e) => setActiveMarketplace(e.target.value)}
            >
              {marketplaces.map((m) => (
                <option key={m.franchise_id} value={String(m.franchise_id)}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>
        ) : (
          activeMarketplace && (
            <div className="oc-active-market-label">
              <Store size={16} strokeWidth={1.8} />
              <span>{activeMarketplace.name}</span>
            </div>
          )
        )}
      </div>

      <div className="oc-user">
        <div className="oc-user-info">
          <div className="oc-user-name">
            {user ? `${user.firstname} ${user.lastname}` : "Guest User"}
          </div>
          <div className="oc-user-role">{user?.username || "admin"}</div>
        </div>
        <div className="oc-avatar">
          {user?.firstname?.[0] || user?.username?.[0] || "U"}
        </div>
      </div>
    </header>
  );
}
